import style from './Header.module.scss';
import Tippy from '@tippyjs/react/headless';
import className from 'classnames/bind';
import {useDispatch, useSelector } from "react-redux";
import {memo, useContext} from "react";
import {
	Image,
	Button,
	PopperWrapper,
	Icon
} from "~/components";
import {currentUserSelector, authActions} from "~/reduxs/Auth/authSlice";
import {globalNavigate} from "~/routes/GlobalHistory";
import {AppContext} from "~/context/AppProvider";
import images from "../../assets/images";
import {Flex, Layout} from "antd";
import NavMobile from "../NavBar/NavMobile";
import NavBar from "../NavBar";
import {Link} from "react-router-dom";
const cn = className.bind(style);
const { Header : HeaderAntd } = Layout;

function Header() {

	const {
		isMobile,
		isTablet,
		isDesktop
	} = useContext(AppContext);

	const dispatch = useDispatch();

	const currentUser = useSelector(currentUserSelector);

	const handleLogout = () => {
		localStorage.clear();
		dispatch(authActions.logout());
		globalNavigate(process.env.REACT_APP_HOMEPAGE+"/login");
	}

	const renderAccountMenu = () => {
		return (
			<PopperWrapper className={cn('account-action')}>
				<Button leftIcon={Icon.user} className={cn('button')} to={'/account/info'}> Thông tin tài khoản</Button>
				<Button leftIcon={Icon.lock} className={cn('button')} to={'/account/password'}> Đổi mật khẩu</Button>
				<hr />
				<Button leftIcon={Icon.logout} onClick={handleLogout} className={cn('button')}> Đăng xuất </Button>
			</PopperWrapper>
		)
	}

	return (
		<HeaderAntd className={cn('header')}>
			<div className={'container'}>
				<Flex justify='space-between' align={'center'}>
					<div className={cn('mobile-logo', 'd-flex', 'align-items-center', 'gap-1')}>
						<Link to={'/'}>
							<Image src={images.logoWhite} style={{height:'50px'}} />
						</Link>
					</div>
					{ isMobile ? <NavMobile /> : <NavBar /> }
					<div className={cn('right')}>
						<Button green background to={'/pos'} leftIcon={Icon.computer}>Bán Hàng</Button>
						{(isDesktop || isTablet) &&
							<Tippy interactive render={renderAccountMenu} placement="bottom" offset={[0, 10]}>
								<div className={cn('account')}>
									<div className={cn('avatar')}><Image src={'https://eduoka.com/images/avatar.png'}/></div>
									<div className={cn('name', 'text-sm')}><span>Xin chào, {currentUser?.lastname}</span></div>
								</div>
							</Tippy>
						}
					</div>
				</Flex>
			</div>
		</HeaderAntd>
	);
}
export default memo(Header);